module.exports = __webpack_public_path__ + "static/img/code.ec69c047.svg";